module.exports = __webpack_public_path__ + "static/media/app-store-badge.2b688da4.png";